const s = {
  name: "BrazilianReal",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,16c-0.5,0-1,0.5-1,1v0.8c0,0.4,0.2,0.7,0.6,0.9l1.8,0.9c1,0.5,1.7,1.5,1.7,2.7V23c0,1.3-0.8,2.4-2,2.8V27
			h-2v-1.2c-1.2-0.4-2-1.5-2-2.8v-1h2v1c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-0.8c0-0.4-0.2-0.7-0.6-0.9l-1.8-0.9
			c-1-0.5-1.7-1.5-1.7-2.7V17c0-1.3,0.8-2.4,2-2.8V13h2v1.2c1.2,0.4,2,1.5,2,2.8v1h-2v-1C25,16.5,24.5,16,24,16z"/>
		<path class="st0" d="M13,26h2v-5h1.2l1.6,5H20l-1.8-5.4c1.1-0.6,1.8-1.7,1.8-3.1c0-1.9-1.6-3.5-3.5-3.5H13V26z M16.5,19H15v-3h1.5
			c0.8,0,1.5,0.7,1.5,1.5C18,18.3,17.3,19,16.5,19z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			c9.9,0,18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as BrazilianReal
};
